/**
 * Webplayer-preview "refetch now" client event.
 *
 * Sibling of `drive-refresh-event.ts`, for the same class of problem: an action kicks off
 * (or reveals) backend work whose result the open config dialog's preview must re-read, and
 * there is no realtime signal to react to. Rather than poll, the action that knows a refresh
 * is warranted dispatches this event, and `useFetchList` — which owns the preview feed fetch —
 * listens and re-fires once.
 *
 * First user: `testSharePointConnection`. SharePoint News posts are crawled server-side and can
 * take hours to land, so the preview can sit on its empty state; a successful Test Connection is
 * the natural moment to re-check, and it fires this event so the pane refetches without the user
 * having to close and reopen the dialog.
 *
 * Payload-free on purpose: only one config dialog (hence one `useFetchList`) is mounted at a time,
 * so the listener refetches its own feed when enabled — there is nothing to disambiguate.
 */
const PREVIEW_REFETCH_EVENT = 'smallapp:preview-refetch';

const dispatchPreviewRefetch = (): void => {
  window.dispatchEvent(new CustomEvent(PREVIEW_REFETCH_EVENT));
};

export { PREVIEW_REFETCH_EVENT, dispatchPreviewRefetch };
